import { gql } from '@apollo/client';

export const GET_LESSON_VOCABULARY_SUGGESTIONS = gql`
  query GetLessonVocabularySuggestions($input: GetVocabularySuggestionsInput!) {
    suggestions(input: $input)
  }
`;

export const UPDATE_LESSON_VOCABULARIES = gql`
  mutation UpdateLessonVocabularies($input: UpdateLessonVocabulariesInput!) {
    updateLessonVocabularies(input: $input) {
      id
      data {
        vocabularies
      }
    }
  }
`;

export const lessonVocabularyFragment = gql`
  fragment LessonVocabularyFragment on Lesson {
    data {
      vocabularies
    }
  }
`;
